<template>
    <div>
        <div class="pt-5 flex justify-start">
            <div class="form-control mr-3">
                <label>Szoba hozzáadásasa</label>
                <input
                    v-model="newRoom.name"
                    @change="newRoom.floor = newRoom.name.substring(0, 1)"
                    @keyup.enter="storeRoomAsync(newRoom)"
                    required
                    class="input input-bordered w-full"
                />
            </div>
            <div @click="storeRoomAsync(newRoom)" class="btn btn-active self-end">Mentés</div>
        </div>
        <div v-for="(rooms, key) in floors" :key="key" class="w-full">
            <div class="text-3xl py-8">{{ key === 'A' ? 'Alagsor' : `${key}. emelet` }}</div>
            <div class="grid grid-cols-6 gap-y-2">
                <div
                    v-for="room in rooms"
                    :key="room.id"
                    class="col-span-3 md:col-span-2 lg:col-span-1"
                >
                    <div class="btn-group">
                        <div class="btn btn-info">{{ room.name }}</div>
                        <div @click="deleteRoomAsync(room)" class="btn btn-error fill-base-content text-base-100">
                            <CloseIcon transparent/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import CloseIcon from "../svg/CloseIcon";

export default {
    name: 'AllowedRooms',
    components: { CloseIcon },
    props: {
        period_id: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            newRoom: {
                name: '',
                capacity: 2,
                floor: '',
                period_id: this.period_id,
            },
        };
    },
    computed: {
        ...mapGetters('Period', ['allowed_rooms']),
        floors() {
            return _.groupBy(this.allowed_rooms, (r) => r.floor);
        },
    },
    methods: {
        ...mapActions('Period', ['getAllowedRoomsAsync', 'storeRoomAsync', 'deleteRoomAsync']),
    },
    mounted() {
        this.getAllowedRoomsAsync(this.period_id);
    },
};
</script>

<style scoped></style>
